import { manageFindYourVehicleBlock } from '../../../actions/siteadmin/manageFindYourVehicleBlock';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;
  await dispatch(manageFindYourVehicleBlock(values));
}

export default submit;